import React from "react";
import Input from "../../../../../components/FormComponents/Input";
import FormButtonGroup from "../../../EditFieldAttribute/FormButtonGroup";
import { getLabelForKey } from "../../../../../utils/Config/DefaultConfig/formFieldConfig";

const EditButtonGroup = (props) => {
  const { editFieldData, setEditFieldData, tableID } = props;
  const handleChangeInput = (name, value) => {
    setEditFieldData({ ...editFieldData, [name]: value });
  };
  const handleChangeButtonGroup = (values) => {
    setEditFieldData({ ...editFieldData, data: { ...editFieldData.data, values } });
  };
  return (
    <>
      <Input
        label={getLabelForKey("label")}
        value={editFieldData.label}
        name="label"
        onChange={({ target }) => handleChangeInput(target.name, target.value)}
      />
      <Input
        label={getLabelForKey("form_display_label")}
        value={editFieldData.form_display_label}
        name="form_display_label"
        onChange={({ target }) => handleChangeInput(target.name, target.value)}
      />
      <Input
        type="checkbox"
        label={getLabelForKey("confirmation_box")}
        checked={editFieldData.confirmation_box}
        name="confirmation_box"
        onChange={({ target }) => handleChangeInput(target.name, target.checked)}
        containerClassName="w_50"
      />
      <FormButtonGroup value={editFieldData.data.values} onChange={handleChangeButtonGroup} tableID={tableID} />
      <div className="field_horizontal_container">
        <Input
          label={getLabelForKey("help_text")}
          value={editFieldData.help_text}
          name="help_text"
          onChange={({ target }) => handleChangeInput(target.name, target.value)}
        />
      </div>
    </>
  );
};

export default EditButtonGroup;
